<template>
  <VRow no-gutters>
    <VCol v-if="sent" cols="12">
      <span>{{ $t('successMessage') }}</span>
    </VCol>
    <VCol v-else cols="12">
      <VTextarea
        v-model="message"
        outlined
        :hide-details="!error.errors.message"
        :error-messages="error.errors.message"
        rows="3"
        background-color="#fff"
        @input="error.errors.message = null"
      >
        <template #label>
          <span class="body-2 grey--text">
            {{ $t('tip') }}
          </span>
        </template>
      </VTextarea>
      <div class="mt-6 text-center">
        <VBtn
          color="primary"
          class="white--text mr-4"
          :loading="isLoading"
          @click="submit"
        >
          {{ $t('send') }}
        </VBtn>
      </div>
    </VCol>
  </VRow>
</template>

<script>
import { detect as detectBrowser } from 'detect-browser';
import { zendeskFields } from '@/enums';
import { getDeviceInfo } from '@/functions';
import ApiMixin from '@/mixins/ApiMixin';

export default {
  name: 'CandidateSupportForm',
  mixins: [ApiMixin],
  props: {
    candidateId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      message: null,
      error: {
        errorMessage: null,
        errors: {},
      },
      sent: false,
      isLoading: false,
    };
  },
  computed: {
    hasErrorMessageOnly() {
      return !Object.keys(this.error.errors).length && this.error.errorMessage;
    },
  },
  methods: {
    async submit() {
      try {
        await this.withApiErrorHandling(async () => {
          const browser = detectBrowser();
          const devicesInfo = await getDeviceInfo();

          await this.$store.dispatch('candidate/support', {
            candidateId: this.candidateId,
            message: this.message,
            fields: [
              { id: zendeskFields.USER_AGENT, value: window.navigator.userAgent },
              { id: zendeskFields.APP, value: 'frontend' },
              { id: zendeskFields.MEDIA_DEVICES, value: devicesInfo },
              { id: zendeskFields.OS, value: browser ? browser.os : null },
              { id: zendeskFields.BROWSER, value: browser ? `${browser.name} ${browser.version}` : null },
            ],
          });
          this.sent = true;
          this.$emit('sent');
        }, 'error', 'isLoading');
      } catch (e) {
        if (this.hasErrorMessageOnly) {
          this.$toast.error(this.error.errorMessage);
        }
      }
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  tip: Tell us what what happened and our support team will try to help you.
  send: Send
  successMessage: Your message has been sent to our support team
</i18n>

<i18n locale="ru" lang="yaml">
  tip: Расскажите, что вы пытались сделать и что произошло.
  send: Отправить
  successMessage: Ваше сообщение отправлено в техподдержку
</i18n>
